
import { supabase } from '@/lib/supabase'

export const signOut = async () => {
  console.log('Tentative de déconnexion...')
  try {
    // Simplified approach with manual cleanup before logout
    // Clear all auth information from localStorage
    for (const key of Object.keys(localStorage)) {
      if (key.includes('supabase.auth') || key.includes('sb-')) {
        localStorage.removeItem(key)
        console.log(`Suppression de la clé localStorage: ${key}`)
      }
    }

    // Call Supabase logout API
    const { error } = await supabase.auth.signOut()
    
    if (error) {
      console.error('Erreur lors de la déconnexion API:', error)
      throw error
    } else {
      console.log('Déconnexion API réussie')
    }
    
    console.log('Déconnexion complète, retour à l\'état de départ')
    
    return { success: true, error: null }
  } catch (error) {
    console.error('Exception lors de la déconnexion:', error)
    return { success: false, error }
  }
}
